/**
 * PackGrid.module.scss — Toile.
 *
 * The reading-row rules carried over from the design-mock transposition this convergence replaces
 * (`styles/PackPage.module.scss`, deleted with it) plus narcis's cell shape (`.detailRow__cell` in
 * PackLandingTemplate.module.scss: fixed ratio, small radius, cover fit). Narcis's own
 * PackGrid.module.scss is the delivered-slot grid — pending pulse, retry cell, failure cell,
 * download pill — and none of it applies to a static sample, so none of it came across.
 *
 * Breakpoints follow narcis's set: the label column collapses at 899 (where the hero grid does),
 * the three-across cells go single-column at 639 (where the thumb strip switches to scroll).
 */

.readingRow {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 18px;
    align-items: start;
}

.readingLabel {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10.5px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--tl-dim);
    padding-top: 4px;
    line-height: 1.6;
}

.readingLabel b {
    display: block;
    color: var(--tl-text);
    font-weight: 400;
    font-family: var(--tl-font);
    font-size: 14px;
    letter-spacing: 0;
    text-transform: none;
}

.readingGrid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    min-width: 0;
}

.cell {
    display: block;
    text-align: left;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    min-width: 0;

    &:focus-visible {
        outline: 2px solid var(--tl-accent);
        outline-offset: 3px;
        border-radius: 4px;
    }
}

.cellImg {
    width: 100%;
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid var(--tl-border);
    background: var(--tl-surface);
}

.cellImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.cell:hover .cellImg {
    border-color: var(--tl-border-strong);
}

@media (max-width: 899px) {
    .readingRow {
        grid-template-columns: 1fr;
        gap: 12px;
    }
}

@media (max-width: 639px) {
    .readingGrid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}
